module.exports = __webpack_public_path__ + "img/public/SiteIcons/paymentArrow.svg?e7a14cda";